const styles = theme => ({
  container: {
    padding: '24px',
    border: '1px solid #D5D6D7',
    background: theme.palette.primary.white,
  },
  dropSelectContainer: {
    maxWidth: '360px',
    marginBottom: '24px',
  },
  feeContainer: {
    display: 'flex',
    alignItem: 'flex-start',
    justifyContent: 'space-between',
  },
  additionalDetailsContainer: {
    marginTop: '16px',
    display: 'flex',
    alignItem: 'flex-start',
    justifyContent: 'space-between',
  },
  feeTextContainer: {
    marginRight: '25px',
  },
  feeText: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
  },
  feeSubText: {
    maxWidth: '420px',
    color: theme.palette.primary.darkGrey,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    marginTop: '3px',
  },
  feeAmount: {
    whiteSpace: 'nowrap',
  },
  feeRed: {
    // color: `${theme.palette.primary.main} !important`,
  },
  totalFeeContainer: {
    padding: '16px 0px',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  adgmAlert: {
    marginTop: '8px',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
    padding: '0px',
    '& span': {
      color: '#595B61',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
  otherFees: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },
  fees: {},
  '@media (max-width:767px)': {
    otherFees: {
      '& $fees': {
        '& p': {
          fontSize: '12px',
          lineHeight: '18px',
        },
      },
    },
    container: {
      padding: '24px 18px',
    },
    dropSelectContainer: {
      maxWidth: '100%',
    },
    feeTextContainer: {
      marginRight: '20px',
    },
    feeText: {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
    },
    feeSubText: {
      maxWidth: '100%',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '18px',
      marginTop: '2px',
    },
    totalFeeContainer: {
      padding: '22px 18px',
    },
  },
  text: {
    fontSize: '14px',
  },
  paidByBold: {
    '&>span': {
      color: '#000',
      fontWeight: '600',
    },
  },
});

export default styles;
